import React from 'react';
import Layout from '../Components/Layout';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useLanguage } from '../context/LanguageContext';

export default function About() {
    const { translations } = useLanguage();
    const t = translations.about || {};

    const options = {
        loop: true,
        margin: 10,
        nav: false,
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
          1000: { items: 3 }
        }
    };

    return (
        <Layout>
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">{t.breadcrumb?.title}</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="/"><i className="isax isax-home5"></i></a></li>
                                    <li className="breadcrumb-item active" aria-current="page">{t.breadcrumb?.title}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section about">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="about-image mb-4 mb-lg-0">
                                <div className="about-listing">
                                    <i className="isax isax-calendar-add text-white mb-2"></i>
                                    <h6 className="fs-16 mb-3 text-white">{t.listing?.title}</h6>
                                    <div className="listing-img">
                                        <div>
                                            <img src="/assets/img/icons/listing.svg" alt="icon"/>
                                        </div>
                                        <a href="add-hotel.html" className="btn btn-warning text-gray-9">{t.listing?.button}</a>
                                    </div>
                                </div>
                                <div className="about-img">
                                    <img src="assets/img/about.svg" alt="about"/>
                                </div>
                                <div className="about-progress d-inline-flex align-items-center">
                                    <img src="/assets/img/icons/progress-icon.svg" alt="icon"/>
                                    <div className="ms-2">
                                        <p className="fs-10 mb-1">{t.earnings?.title}</p>
                                        <h6 className="fs-13">$2500</h6>
                                    </div>
                                    <a href="wallet.html" className="btn btn-teal btn-sm fw-normal ms-4">{t.earnings?.button}</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-content mb-4">
                                <h6 className="text-primary fs-14 fw-medium mb-2">{t.mainContent?.subtitle}</h6>
                                <h2 className="display-6 mb-2">{t.mainContent?.title}</h2>
                                <p className="mb-4">{t.mainContent?.description}</p>
                                <div className="d-flex align-items-center mb-4">
                                    <span className="avatar avatar-xl bg-primary rounded-circle flex-shrink-0 me-3">
                                        <i className="isax isax-map5 fs-24"></i>
                                    </span>
                                    <p>{t.mainContent?.b2bDescription}</p>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="avatar avatar-xl bg-secondary rounded-circle flex-shrink-0 me-3">
                                        <i className="isax isax-trade5 fs-24 text-gray-9"></i>
                                    </span>
                                    <p>{t.mainContent?.b2cDescription}</p>
                                </div>
                            </div>
                            <div className="about-mission">
                                <h6 className="text-primary fs-14 fw-medium mb-3">{t.mission?.title}</h6>
                                <p className="fs-16 text-gray-6">{t.mission?.description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="about-bg d-none d-md-block">
                        <img src="assets/img/bg/about-bg.png" alt="img" className="about-bg-01"/>
                    </div>
                    <div className="about-bg-1 d-none d-md-block">
                        <img src="assets/img/bg/about-arrow.png" alt="img" className="about-bg-01"/>
                    </div>
                </div>
            </section>

            <section className="section choose-us-section">
                <div className="container">
                    <div className="choose-title">
                        <h2>{t.whyChooseUs?.title} <span className="text-primary">{t.whyChooseUs?.titleHighlight}</span></h2>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-3">
                            <div className="choose-card">
                                <div className="choose-icon mb-3">
                                    <span className="rounded-circle d-flex align-items-center justify-content-center">
                                        <i className="isax isax-archive-tick text-white"></i>
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6 className="mb-2">{t.whyChooseUs?.features?.convenience?.title}</h6>
                                    <p className="fs-16 text-gray-6">{t.whyChooseUs?.features?.convenience?.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="choose-card">
                                <div className="choose-icon mb-3">
                                    <span className="rounded-circle d-flex align-items-center justify-content-center">
                                        <i className="isax isax-dollar-square text-white"></i>
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6 className="mb-2">{t.whyChooseUs?.features?.bestPrice?.title}</h6>
                                    <p className="fs-16 text-gray-6">{t.whyChooseUs?.features?.bestPrice?.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="choose-card">
                                <div className="choose-icon mb-3">
                                    <span className="rounded-circle d-flex align-items-center justify-content-center">
                                        <i className="isax isax-headphone text-white"></i>
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6 className="mb-2">{t.whyChooseUs?.features?.support?.title}</h6>
                                    <p className="fs-16 text-gray-6">{t.whyChooseUs?.features?.support?.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="choose-card">
                                <div className="choose-icon mb-3">
                                    <span className="rounded-circle d-flex align-items-center justify-content-center">
                                        <i className="isax isax-map text-white"></i>
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6 className="mb-2">{t.whyChooseUs?.features?.experience?.title}</h6>
                                    <p className="fs-16 text-gray-6">{t.whyChooseUs?.features?.experience?.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="choose-bg-01">
                        <img src="/assets/img/bg/about-bg-stars-bottom.png" alt="image" className="img-fluid"/>
                    </div>
                    <div className="choose-bg-01">
                        <img src="/assets/img/bg/about-bg-stars-bottom.png" alt="image" className="img-fluid"/>
                    </div>
                    <div className="choose-bg-02">
                        <img src="/assets/img/bg/about-bg-stars-top.png" alt="image" className="img-fluid"/>
                    </div>
                </div>
            </section>

            <section className="section testimonial-section bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-10 wow fadeInUp text-center" data-wow-delay="0.2s">
                            <div className="section-header text-center">
                                <h2 className="mb-2">{t.testimonials?.title}</h2>
                                <p className="sub-title">{t.testimonials?.subtitle}</p>
                            </div>
                        </div>
                    </div>
                    <OwlCarousel className="owl-carousel testimonial-slider" {...options}>
                        {t.testimonials?.items?.map((testimonial) => (
                            <div key={testimonial.id} className="card wow fadeInUp border-white" data-wow-delay="0.2s">
                                <div className="card-body">
                                    <h6 className="mb-4">{testimonial.title}</h6>
                                    <p className="mb-4">{testimonial.text}</p>
                                    <div className="border-top d-flex align-items-center justify-content-between pt-4">
                                        <div className="d-flex align-items-center">
                                            <a href="javascript:void(0);" className="avatar avatar-md flex-shrink-0">
                                                <img src={`assets/img/users/user-0${testimonial.id}.jpg`} className="rounded-circle" alt="img" />
                                            </a>
                                            <div className="ms-2">
                                                <h6 className="fs-16 fw-medium">
                                                    <a href="javascript:void(0);">{testimonial.name}</a>
                                                </h6>
                                                <p>{testimonial.location}</p>
                                            </div>
                                        </div>
                                        <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                                            {testimonial.rating}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </OwlCarousel>
                </div>
                <div className="testimonial-bg">
                    <img src="assets/img/bg/testimonial-bg-01.svg" alt="img"/>
                </div>
            </section>
        </Layout>
    );
}
